import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { StatusFromBackofficeActionTypes } from '../State/actions/statusFromBackoffice.actions';
import { getStatusFromBackofficeFetched } from '../State/selectors/statusFromBackoffice.selectors';
import { BaseEntityResolver } from './resolver.helper';

@Injectable({
    providedIn: 'root',
})
export class StatusFromBackofficeResolver extends BaseEntityResolver {
    constructor(store: Store<State>) {
        super(getStatusFromBackofficeFetched, StatusFromBackofficeActionTypes.GetStatusFromBackofficeRequest(), store);
    }
}
